import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import '../App.css';
import './LegalPages.css';

const S = ({t, children}) => (
  <section className="legal-section">
    <h2 className="heading-3">{t}</h2>
    {children}
  </section>
);
const P = ({children}) => <p className="body-regular">{children}</p>;

const Impressum = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <Link to="/" className="back-link"><ArrowLeft size={18} /> Zurueck zur Startseite</Link>
        <div className="legal-content">
          <h1 className="heading-1">Impressum</h1>

          <S t="Angaben gemaess Paragraph 5 TMG">
            <P>BD Event Location<br />Pfarrer-Adam-Haus-Strasse 6a<br />63939 Woerth am Main<br />Deutschland</P>
            <P><em>Geschaeftsfuehrer / Inhaber: [Bitte ergaenzen]</em></P>
          </S>

          <S t="Kontakt">
            <P>Telefon: <a href="tel:+491793912947" className="legal-link">+49 179 3912947</a><br />
            E-Mail: <a href="mailto:event.service.woerth@gmail.com" className="legal-link">event.service.woerth@gmail.com</a></P>
          </S>

          <S t="Umsatzsteuer-ID">
            <P>Umsatzsteuer-Identifikationsnummer gemaess Paragraph 27a Umsatzsteuergesetz:<br /><em>[Bitte USt-IdNr. ergaenzen, falls vorhanden]</em></P>
          </S>

          <S t="Verantwortlich fuer den Inhalt nach Paragraph 55 Abs. 2 RStV">
            <P>BD Event Location<br />Pfarrer-Adam-Haus-Strasse 6a<br />63939 Woerth am Main</P>
          </S>

          <S t="EU-Streitschlichtung">
            <P>Die Europaeische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" className="legal-link" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</a>. Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</P>
          </S>

          <S t="Haftung fuer Inhalte">
            <P>Als Diensteanbieter sind wir gemaess Paragraph 7 Abs. 1 TMG fuer eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach Paragraphen 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, uebermittelte oder gespeicherte fremde Informationen zu ueberwachen oder nach Umstaenden zu forschen, die auf eine rechtswidrige Taetigkeit hinweisen.</P>
            <P>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberuehrt. Eine diesbezuegliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung moeglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</P>
          </S>

          <S t="Haftung fuer Links">
            <P>Unser Angebot enthaelt Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb koennen wir fuer diese fremden Inhalte auch keine Gewaehr uebernehmen. Fuer die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</P>
            <P>Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf moegliche Rechtsverstoesse ueberprueft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</P>
          </S>

          <S t="Urheberrecht">
            <P>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfaeltigung, Bearbeitung, Verbreitung und jede Art der Verwertung ausserhalb der Grenzen des Urheberrechtes beduerfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</P>
            <P>Downloads und Kopien dieser Seite sind nur fuer den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet.</P>
          </S>

          <S t="Design und Umsetzung">
            <P>Website-Design und technische Umsetzung: BA Media Performance</P>
          </S>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
